import { render, staticRenderFns } from "./AddNotice.vue?vue&type=template&id=787efa14&scoped=true"
import script from "./AddNotice.vue?vue&type=script&lang=js"
export * from "./AddNotice.vue?vue&type=script&lang=js"
import style0 from "./AddNotice.vue?vue&type=style&index=0&id=787efa14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787efa14",
  null
  
)

export default component.exports